import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { services } from '../../data/mock';
import ServiceIcon from '../ui/ServiceIcon';

const ServicesSection = () => {
  return (
    <section className="bg-white py-16">
      <div className="container-main">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Left Column - Title and Contact */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy font-display mb-4">What we offer</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-6 max-w-sm">
              Elevate Youth: A Consultancy Venture for Tomorrow's Leaders is a dynamic and forward-thinking.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-navy text-white px-6 py-3 rounded-full text-sm font-medium"
            >
              Contact
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>

          {/* Right Column - Services List */}
          <div className="space-y-6">
            {services.map((service) => (
              <div
                key={service.id}
                className="flex items-start gap-4 pb-6 border-b border-gray-100 last:border-0"
              >
                <div className="w-12 h-12 bg-lime rounded-full flex items-center justify-center flex-shrink-0">
                  <ServiceIcon type={service.icon} className="w-6 h-6 text-navy" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-navy mb-1">{service.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
